import { Colors, Icon, Tooltip } from '@blueprintjs/core'
import * as React from 'react'
import { UserPermission } from '../current/types'
import { usePermissions } from '../hooks/usePermissions'
import { UprightStyle } from '../types'

interface Props {
  className?: string
  onClick: React.MouseEventHandler
  requiredPermission: UserPermission
}

const style: UprightStyle = {
  button: {
    cursor: 'pointer',
    color: Colors.DARK_GRAY3,
    marginBottom: 0
  },
  disabledButton: {
    cursor: 'not-allowed',
    color: Colors.GRAY3,
    marginBottom: 0
  }
}

export const ExportButton = (props: Props) => {
  const { permissions } = usePermissions()
  const disabled = !permissions.includes(props.requiredPermission)
  return (
    <Tooltip disabled={!disabled} content="You do not have permission to export this data">
      <p
        style={disabled ? style.disabledButton : style.button}
        className={props.className}
        onClick={disabled ? undefined : props.onClick}
      >
        Export <Icon icon="download" color={disabled ? Colors.GRAY4 : Colors.GRAY1} />
      </p>
    </Tooltip>
  )
}
